// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Comment Lines
// MODIFIED DATE: 25-09-2025

const ClosedLoanReportActionTypes = {
	/****************  GET CLOSED LOAN DETAILS LIST START *********************** */
	GET_CLOSED_LOAN_DETAILS_LIST_START: 'get_closed_loan_details_start',
	GET_CLOSED_LOAN_DETAILS_LIST_SUCCESS: 'get_closed_loan_details_success',
	GET_CLOSED_LOAN_DETAILS_LIST_FAILURE: 'get_closed_loan_details_failure',
	GET_CLOSED_LOAN_DETAILS_LIST_RESPONSE_RESET: 'get_closed_loan_details_response_reset',
	GET_CLOSED_LOAN_DETAILS_LIST_RESPONSE_CHANGED: 'get_closed_loan_details_response_changed',
	/****************  GET CLOSED LOAN DETAILS LIST END *********************** */
};
export default ClosedLoanReportActionTypes;
